// Re-export types from switch-core (single source of truth)
export type {
  Message,
  MessageTypeEnum,
  Attachment,
  GroupUpdatedMessageContent,
  CommunityUpdatedMessageContent,
} from "@/core_bridge/module_api";

// Re-export enum constants
export {
  ContentType,
  MessageType,
  MessageStatus,
  AttachmentMimeType,
  Environment,
  GroupUpdateReason,
  CommunityUpdateReason,
} from "@/core_bridge/module_api";

// Re-export validation functions
export { validateMessage, parseMessage, stringifyMessage, safeValidateMessage } from "@/core_bridge/module_api";

import { Message } from "@/core_bridge/module_api";
import { validateMessage, safeValidateMessage } from "@/core_bridge/module_api";

// Schema compatibility layer - uses core validation via Rust WASM
export const messageSchema = {
  parse: (data: unknown): Message => {
    // Route through core validation for consistent validation across platforms
    return validateMessage(data);
  },
  safeParse: (data: unknown) => {
    // Use core's safe validation
    const result = safeValidateMessage(data);
    if (result.success) {
      return { success: true as const, data: result.data };
    }
    return { success: false as const, error: new Error(result.error) };
  },
};

// Type for creating a new message (omit auto-generated fields)
export type CreateMessageInput = Omit<Message, "id" | "createdAt" | "updatedAt" | "status">;

// Helper to transform message for push notification (pick only needed fields)
export function messageForPush(message: Message): Record<string, string> {
  const result: Record<string, string> = {};
  const keys = [
    "id", "type", "roomId", "senderId", "receiverId",
    "threadKey", "groupId", "communityId", "createdAt", "updatedAt"
  ] as const;

  for (const key of keys) {
    const value = message[key];
    if (value !== undefined && value !== null) {
      result[key] = String(value);
    }
  }

  if (message.attachment) {
    result.attachment = JSON.stringify(message.attachment);
  }

  return result;
}
